import { DATEVERSION } from "../../actions/portal/";

export default function(state = "", action){
  switch (action.type) {
    case DATEVERSION:
    return action.payload;
    default:
  }

  return state;
}
